import { PureComponent } from "react";
import { StyledFactDetailsComponent } from "./fact-details-component.scss";
import { convertToArrayIfNeeded } from "utils/arrays";

export default class FactDetailsComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  renderParagraphs(paragraphs) {
    return paragraphs.map((paragraph, index) => <div key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />);
  }

  render() {
    const { title, body } = this.props;
    let contentBody = convertToArrayIfNeeded(body);
    contentBody = this.renderParagraphs(contentBody);

    return (
      <StyledFactDetailsComponent className="fact-details-component">
        <div className="title">{title}</div>
        <div className="content">{contentBody}</div>
      </StyledFactDetailsComponent>
    );
  }
}
